import React from 'react';
import './news.css';
import { connect } from 'react-redux';
import {
  updateNewsFilter,
  updateSelectedNews
} from '../../../actions/adminActions/adminNewsActions';
import { newsLog } from '../../../apis/backend'; //make sure to include this for each page
import EditModal from './newsModals/editModal.jsx';
import AddModal from './newsModals/addModal.jsx';
import ReadModal from './newsModals/readModal.jsx';

class news extends React.Component {
  async newsDeleteRequest(id) {
    await newsLog
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  rendernews() {
    // console.log(this.props.selectedNews);
    //renders the news table
    return (
      <>
        {this.props.news
          .filter((news) => {
            const filterString = `${news.title}`;
            return filterString.toLowerCase().indexOf(this.props.newsFilter.toLowerCase()) > -1;
          })
          .map((news) => (
            <tr key={this.props.news.indexOf(news)}>
              <td className="text-center" style={{ width: '20%' }}>
                {`${news.title}`}
              </td>
              <td className="text-center " style={{ width: '15%' }}>
                <div
                  data-target="#readModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedNews(news.id);
                    // console.log(this.props.selectedNews);
                  }}
                >
                  Read Status
                </div>
              </td>
              <td className="text-center " style={{ width: '9%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedNews(news.id);
                    // console.log(this.props.selectedNews);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center " style={{ width: '9%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedNews(news.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getNewsTitle() {
    const news = this.props.news.find((obj) => obj.id === this.props.selectedNews);

    return news ? news.title : '';
  }

  render() {
    return (
      <div className="news-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>News</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.newsFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateNewsFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Create Announcment
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '20%' }}>
                    Title
                  </th>
                  <th className="text-center " style={{ width: '15%' }}>
                    Read Status
                  </th>
                  <th className="text-center " style={{ width: '9%' }}>
                    Edit
                  </th>
                  <th className="text-center " style={{ width: '9%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.rendernews()}</tbody>
            </table>
          </div>
        </div>

        <AddModal />

        <EditModal />

        <ReadModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedNews(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getNewsTitle()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.newsDeleteRequest(this.props.selectedNews);
                    this.props.updateSelectedNews(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedNews(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  news: state.admin.admin.news,
  newsFilter: state.admin.news.newsFilter,
  selectedNews: state.admin.news.selectedNews,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateNewsFilter,
  updateSelectedNews
})(news);
